import type { FaireProductEntity } from "../../entity_types/product";

export const p_wsuc2pf6zj: FaireProductEntity = {
  token: "p_wsuc2pf6zj",
  type: "product",
  name: "Hand-painted Ceramic Photo Frame, Red Flowers",
  brandToken: "b_5wxf7f7xvq",
  brandName: "ChagoArt",
  imageUrl:
    "https://cdn.faire.com/fastly/25927460749bca98b90a07997238a5ca803b7a59420bed0ff7062f2684a73ee8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/55d7d0da27f565ed3fb72cc5fdea4fb1b0b85636a51de51fa30b806b720b7d84.jpeg",
    "https://cdn.faire.com/fastly/a7a82e72dbee7b850c1d2977bd55729769ea4655760e16b061effbaa547702dc.jpeg",
  ],
  priceDollars: 9.59,
  description:
    'Hand-painted Ceramic Photo Frame, Red Flowers\n\n-\t4.5" x 4.5" x 0.3"\n-\t100% Stoneware\n\nChagoArt was founded in Los Angeles in 2024 by Chaoqun Chen. A portion of our profits is donated to children\'s hospital.\n\nRetailers: gift shop, planter greenery, nursery stores, coffee flower floral stores, home goods stores, general stores, boutique, garden center, museum store, home kitchen store, bookstore, stationery, candle store. \n\nPeople also consider: mother\'s day gift, gift for mom, summer gift, tupli flower, gift for Eco-Conscious, gifts under $15, novelty gift, Christmas gift, stocking stuffers, fall winter gift, Christmas filler, gift for mom, gift for her, gift for friends, family, birthday, holiday gift',
  tags: [],
  msrpDollars: 19.18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:52.850Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
